import * as React from "react";
import { HexColorPicker } from "react-colorful";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function ColorPicker({ value, onChange }) {
  const [color, setColor] = React.useState(value || "#000000");

  const handleChange = (newColor) => {
    setColor(newColor);
    if (onChange) {
      onChange(newColor); // expose selected color
    }
  };

  const handleInputChange = (e) => {
    let val = e.target.value;
    if (!val.startsWith("#")) val = "#" + val;
    if (/^#([0-9A-Fa-f]{3}){1,2}$/.test(val)) {
      handleChange(val);
    } else {
      setColor(val); // show typed value even if invalid
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="h-9 bg-muted p-1 rounded-md w-fit flex items-center gap-2">
          <Button
            variant="outline"
            className="w-7 h-7 rounded-md p-0 border"
            style={{ backgroundColor: color }}
            onClick={(e) => e.preventDefault()}
          />
          <div>{color}</div>
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-3 w-60 space-y-3">
        {/* Boxed input for HEX */}
        <Input value={color} onChange={handleInputChange} maxLength={7} />

        {/* Color picker */}
        <HexColorPicker color={color} onChange={handleChange} />
      </PopoverContent>
    </Popover>
  );
}
